const prefix = '[OrgUnit]';

export class LoadOrgUnits {
    static readonly type = `${prefix} Load`;
    constructor(public readonly payload = { pageSize: 20 }) {}
}

export class LoadMoreOrgUnits {
    static readonly type = `${prefix} Load More`;
}

export class LoadAllOrgUnits {
    static readonly type = `${prefix} Load All`;
}
